import { autoinject, computedFrom } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import * as moment from 'moment';
import 'moment-timezone';
import numeral from 'numeral';
import { FormattingHelper } from '../../helpers/formatting-helper';
import { PhoneFormat } from '../../helpers/phone-format';
import { PortalUtility } from '../../helpers/utility';
import { Customer } from '../../models/customer';
import { TemplateData } from '../../models/template-data';
import { State } from '../../services/global-state';
import { ICustomerAccountToPay } from '../../services/hpf-transaction-service';
import { PayrazrService } from '../../services/payrazr';
import { PortalTemplateTypes, TemplateService } from '../../services/template-service';
import { ValidationHelpers } from '../../services/validation-helpers';
import { NumberHelper } from '../../smart/helpers/number-helper';
import { AccountPaymentItem } from '../../smart/models/account-payment-item';
import { PaymentItemType } from '../../smart/models/enums/payment-item-type';
import { PaymentItemTableConfiguration } from '../../smart/models/payment-item-table-configuration';
import { ValidationController, ValidationControllerFactory } from 'aurelia-validation';
import { PaymentItem } from '../../smart/models/payment-item';
import { SubmitDigitalWalletPaymentRequest } from '../../models/submit-digital-wallet-payment-request';
import { ApplePaySettings, ApplePayUtil, DigitalWalletPaymentDetails, DigitalWalletPaymentPlanDetails, DigitalWalletType } from '../../models/digital-wallet';
import { DialogService } from 'aurelia-dialog';
import { LegalTermsDialog } from '../../components/legal-dialog/legal-terms.dialog';
import { PaymentFeeType } from '../../models/hpfApi';
import { SelectMerchant } from '../../components/select-merchant/select-merchant';
import { Merchant } from '../../models/merchant';
import { PaymentPlanType } from '../../models/paymentPlanType';
import { MerchantConsumerPortalFeeSettings } from '../../models/merchant-consumer-portal-fee-settings';
import { MfaTwoFactorMethod } from '../../models/mfa/mfa-two-factor-method';

@autoinject
export class EZPay {
	requireAccountLookup: any = false;
	askForAccountNumber: any = false;

	enforceMinPayment: any = false;
	pageState: any = 'start';
	validationErrors: any = [];
	displayAccountBalanceOnPaymentForm: boolean = true;
	minimumPaymentAmountMesssage: string = '';
	customMessage: string = '';

	enableEditTransaction: boolean = false;
	paymentMethodViewModel: any;

	payrazrService: PayrazrService;
	templateService: TemplateService;
	globalState: State;
	router: Router;
	utility: PortalUtility;
	showReferenceId: any;
	accountNumberSettings: any;
	model: any;
	pageStates: any;
	movingToConfirmationPage: any;
	hasLocatedAccount: any;
	customer: any;
	account: any;
	bannerAlignment: any;
	paymentDateSettings: any;
	paymentInformation: any;
	customerAccountNumberComponent: any;
	amount: any;
	minFuture: any;
	maxFuture: any;
	errorMessage: string;
	allowFuturePayment: any = false;
	allowPayToday: any = false;
	title: any;
	confirmationId: any;
	date: any;
	time: any;
	type: any;
	subtotal: any;
	serviceFee: any;
	total: any;
	info: any;
	name: string;
	result: any;
	pnref: any;
	transactionError: any;
	i18n: any;
	paymentLabel: string;
	planId: any;
	portalTemplateType: any;
	merchantKey: number;
	savedPaymentMethodToWallet: any;
	resultCode: any;
	resultMessage: any;
	cardNumber: any;
	linkText: string;
	termsLink: string;
	confirmationTemplateData: TemplateData;
	isSubmitting = false;
	isTodayPayment: boolean;
	disablePaymentAmountField: boolean;
	paymentAmountSettings: any;
	paymentItemTableConfiguration: PaymentItemTableConfiguration;
	calculatedFeeAmount: number;
	paymentItemTableAccounts: Array<number> = [];
	paymentItemTableBusinessKey: number;
	calculatedTotalAmount: number;
	paymentItemTableViewModel: any;
	accountPayments: ICustomerAccountToPay[];
	selectedCustomerAccountKeys: number[];
	validationController: ValidationController;
	canShowBanner: boolean = true;
	displayEzpayAgreeTermsError: boolean = false;
	selectedPaymentItemsChanged(selectedPaymentItems: PaymentItem[]) { }
	paymentFeeType: PaymentFeeType = PaymentFeeType.SingleOrSingleFuturePayment;
	isDigitalWalletPayment: boolean = false;
	showSelectMerchant: boolean = false;
	merchantList:Array<Merchant> = [];
	selectMerchantComponent: SelectMerchant;
	selectedMerchant: Merchant;
	merchantConsumerPortalFeeSettings: MerchantConsumerPortalFeeSettings = new MerchantConsumerPortalFeeSettings();
	isEzpay: boolean;
	recpatchaV2Token: string;
	verificationCode: string;
	mfaEmail: string = null;
	mfaPhoneNumber: string = null;

	paymentItemsLoaded(paymentItems: PaymentItem[]) {
		// apply passthrough params for registered ezpay, if specified in url
		try {
			if (this.payrazrService.getParameterValue('locked') === '1') {
				this.paymentItemTableConfiguration.isPaymentAmountEditable = false;
			}

			let amountString: string = '';

			if (this.payrazrService.getParameterValue('paymentAmount')) {
				amountString = this.payrazrService.getParameterValue('paymentAmount').substr(0, 12);
			}

			if (this.payrazrService.getParameterValue('UMtransAmt')) {
				amountString = this.payrazrService.getParameterValue('UMtransAmt').substr(0, 12);
			}

			let parsedAmount = parseFloat(amountString);
			if (!isNaN(parsedAmount)) {
				// for ezpay there should only be one account, but still loop just in case
				paymentItems.forEach(p => { p.enteredAmount = numeral(parsedAmount).format('0.00'); });
			}
		}
		catch (err) {
			console.error('Error encountered in querystring params.');
		}

		this.updateAccountTableSubtotal();
	}
	enteredAmountChanged(changedItem: PaymentItem) {
		this.updateAccountTableSubtotal();
	}

	constructor(payrazrService: PayrazrService,
			 templateService: TemplateService,
			 state: State, 
			 router: Router, 
                utility: PortalUtility, 
                i18n: I18N, 
			private phoneFormat: PhoneFormat,
			validationControllerFactory: ValidationControllerFactory,
			private dialogService: DialogService,
		private eventAggregator: EventAggregator
		) {
		this.validationController = validationControllerFactory.createForCurrentScope();
		this.payrazrService = payrazrService;
		this.templateService = templateService;
		this.globalState = state;
		this.router = router;
		this.utility = utility;
		this.showReferenceId = false;
		this.accountNumberSettings = {};
		this.i18n = i18n.i18next;
		this.merchantConsumerPortalFeeSettings.feesEnabled = false;
		this.model = new Model();
		this.pageStates = {
			start: {},
			terms: {},
			disclosures: {},
			payment: {},
			confirmation: {},
			receipt: {},
			mfa: {}
		};

		this.movingToConfirmationPage = false;
		this.hasLocatedAccount = false;
		this.customer = null;
		this.account = null;
		this.paymentLabel = this.i18n.t('paymentDate', 'Payment Date');
		this.linkText = `<a href="#">${this.i18n.t('termsAndConditions', 'terms and conditions')}</a>`;
		this.termsLink = this.i18n.t('portalLoginAgreeToTermsAndConditions', {
			defaultValue: `I agree to the ${this.linkText}.`, link: this.linkText
		});
		this.isEzpay = true;
	}

	defaultEzPayFields() {// set defaults for existing merchants that haven't resaved portal settings in VT portal settings since this enhancement
		if (this.globalState.business.portalSettings.ezpay.registrationIdSettings === undefined) {
			this.globalState.business.portalSettings.ezpay.registrationIdSettings = { required: false };
		}

		if (this.globalState.business.portalSettings.ezpay.registrationId2Settings === undefined) {
			this.globalState.business.portalSettings.ezpay.registrationId2Settings = { required: false };
		}

		if (this.globalState.business.portalSettings.ezpay.registrationId3Settings === undefined) {
			this.globalState.business.portalSettings.ezpay.registrationId3Settings = { required: false };
		}

		if (this.globalState.business.portalSettings.ezpay.zipcodeSettings === undefined) {
			this.globalState.business.portalSettings.ezpay.zipcodeSettings = { required: true };
		}
	}

	start() {
		let hideEzpayTerms = document.getElementById('ezpay-t-c-agreed') as HTMLInputElement;
		this.globalState.hideEzpayTerms = hideEzpayTerms.checked ? true : false;

		if (!this.globalState.hideEzpayTerms) {
			this.displayEzpayAgreeTermsError = true;
			return;
		}

		let hideTerms = this.globalState.business.portalSettings.businessSettings.hideTerms
			|| this.globalState.hideEzpayTerms
			|| this.globalState.business.portalSettings.businessSettings.hideTermsAck;
		let hideDisclosures = this.globalState.business.portalSettings.businessSettings.hideDisclosures;

		if (hideTerms === false) {
			this.pageState = this.pageStates.terms;
			return;
		}

		if (hideDisclosures === false) {
			this.pageState = this.pageStates.disclosures;
			return;
		}

		this.pageState = this.pageStates.payment;
		this.doContinue();
	}

	activate() {
		this.defaultEzPayFields();

		this.showReferenceId = true;
		this.accountNumberSettings = this.globalState.business.portalSettings.ezpay.accountNumberSettings;

		let displayAccountBalance = this.globalState.business.portalSettings.ezpay.displayAccountBalanceOnPaymentForm;
		this.displayAccountBalanceOnPaymentForm = displayAccountBalance !== undefined ? displayAccountBalance : true;

		this.requireAccountLookup = this.globalState.business.portalSettings.ezpay.accountNumberHandling.toLowerCase() === 'lookup';
		this.askForAccountNumber = this.globalState.business.portalSettings.ezpay.accountNumberHandling.toLowerCase() !== 'hide';

		this.enforceMinPayment = this.globalState.business.portalSettings.requireMinPayment;

		this.pageState = this.getPageStartState();

		let bannerAlign = this.globalState.business.portalSettings.bannerAlignment;
		this.bannerAlignment = bannerAlign ? bannerAlign : 'left';

		this.paymentDateSettings = this.globalState.business.portalSettings.fields.paymentDate;
		if (!!this.paymentDateSettings && !this.paymentDateSettings.label) { this.paymentDateSettings.label = this.paymentLabel; }

		// payment item table initialization
		this.paymentItemTableConfiguration = new PaymentItemTableConfiguration();
		this.paymentItemTableConfiguration.itemType = PaymentItemType.Account;
		this.paymentItemTableConfiguration.selectFirstItemUponLoad = true;
		this.paymentItemTableConfiguration.enableItemSelection = false;
		this.paymentItemTableConfiguration.onlyShowSelected = true;
		this.paymentItemTableConfiguration.showPaymentAmount = true;
		this.paymentItemTableConfiguration.isPaymentAmountEditable = true;
		this.paymentItemTableConfiguration.isPayInFull = false;
		this.paymentItemTableConfiguration.showStatementLink = false;
		this.paymentItemTableConfiguration.showInitialAmount = this.displayAccountBalanceOnPaymentForm;
		this.paymentItemTableConfiguration.paymentAmountLabel = this.globalState.business.portalSettings.fields.paymentAmount.label || null;

		this.paymentItemTableBusinessKey = this.globalState.business.key;

		this.paymentAmountSettings = this.globalState.business.portalSettings.fields.paymentAmount;
		if (!!this.paymentAmountSettings && !this.paymentAmountSettings.label) { this.paymentAmountSettings.label = this.i18n.t('paymentAmount', 'Payment Amount'); }

		this.model.paymentDate = moment.tz(this.globalState.business.businessTimezone).format('MM/DD/YYYY');
	}

	attached() {
		this.utility.scrollToTop();
		if (!this.showStartButton)
			this.showBannerImage(!this.showTerms);
		// if (this.selectMerchantComponent)
		// 	this.selectMerchantComponent.validate(errors);
	}

	getPageStartState() {
		let needStartButton = this.globalState.business.portalSettings.ezpay.ezpayOnly && this.globalState.business.portalSettings.ezpay.ezpayOnlyStartButton;

		if (needStartButton) {
			return this.pageStates.start;
		}
		else {
			let hideDisclosures = this.globalState.business.portalSettings.businessSettings.hideDisclosures;
			let hideTerms = this.globalState.business.portalSettings.businessSettings.hideTerms
				|| this.globalState.hideEzpayTerms
				|| this.globalState.business.portalSettings.businessSettings.hideTermsAck;

			if (hideTerms === false) {
				return this.pageStates.terms;
			}

			if (hideDisclosures === false) {
				return this.pageStates.disclosures;
			}

			this.doContinue();
			return this.pageStates.payment;

		}
	}

	showBannerImage(show: boolean = true){
		this.canShowBanner = show;
		var footerLogo = document.getElementById('footer-logo');
		if (footerLogo) {
			if (show) {
				footerLogo.removeAttribute("hidden")
			} else {
				footerLogo.setAttribute("hidden", "true");
			}
		}
	}

	termsAgreed() {
		this.showBannerImage();
		if (this.globalState.business.portalSettings.businessSettings.hideDisclosures !== undefined && this.globalState.business.portalSettings.businessSettings.hideDisclosures === true) {
			this.pageState = this.pageStates.payment;
			this.doContinue();
		} else {
			this.pageState = this.pageStates.disclosures;
		}
	}

	disclosuresAgreed() {
		this.pageState = this.pageStates.payment;
		this.doContinue();
	}

	reset() {
		this.validationErrors = new Array();
	}

	returnToEzpayForm() {
		this.movingToConfirmationPage = false;
		this.pageState = this.pageStates.payment;
	}

	get paymentMethodDescription() {
		return this.paymentInformation.card
			? this.paymentInformation.card.description
			: this.paymentInformation.check.description;
	}

	get isCardPayment(): boolean {
		return !!this.paymentInformation.card || this.paymentInformation.digitalWalletSettings?.isCard();
	}

	get isCheckPayment(): boolean {
		return !this.isCardPayment;
	}

	get isApplePayPayment(): boolean {
		return this.isDigitalWalletPayment && this.paymentInformation.digitalWalletSettings?.isApplePay();
	}

	isNullOrWhitespace(input) {

		if (typeof input === 'undefined' || input == null ) {
			return true;
		}

	return input.replace(/\s/g, '').length < 1;
	}

	returnToLogin() {
		if (this.globalState.business.portalSettings.ezpay.ezpayUseExitUrl &&
			!this.isNullOrWhitespace(this.globalState.business.portalSettings.ezpay.ezpayExitUrl)) {
			this.router.navigate(this.globalState.business.portalSettings.ezpay.ezpayExitUrl);
		}
		else if (this.globalState.business.portalSettings.ezpay.ezpayOnly) {
			this.router.navigateToRoute('logout');
		} else {
			this.router.navigateToRoute('login');
		}
	}

	editTransaction() {
		this.pageState = this.pageStates.payment;
		this.paymentMethodViewModel.clearPciData();
	}

	doContinue() {
		this.utility.scrollToTop();

		let customer = Customer.anonymous(
			this.globalState.business,
			this.model.accountReferenceId,
			this.globalState.business.portalSettings.systemId || null,
			null,
			this.model.bucket ? this.model.bucket.bucketKey : null
		);

		this.customer = null;
		this.account = customer.accounts[0];
		this.amount = 0;
		this.applyUnvalidatedMultiMerchantPortfolio(this.account.portfolioName);
		this.globalState.business.applyPortfolioSettingsToPortal(this.account.portfolioName, true, 0);
		this.applyPortfolioSettingsToPage();

		if (!this.requireAccountLookup) {
			this.applyMerchantSettingsToPage(this.account.portfolioName);
			this.applyQueryStringParams(this.payrazrService);
			this.hasLocatedAccount = !this.showSelectMerchant;
		}
	}

	applyQueryStringParams(params) {
		if (!params) {
			return;
		}

		try {
			if (params.getParameterValue('locked') === '1') {
				this.disablePaymentAmountField = true;
			}

			let amountString: string = '';

			if (params.getParameterValue('paymentAmount')) {
				amountString = params.getParameterValue('paymentAmount').substr(0, 12);
			}

			if (params.getParameterValue('UMtransAmt')) {
				amountString = params.getParameterValue('UMtransAmt').substr(0, 12);
			}

			let parsedAmount = parseFloat(amountString);
			if (!isNaN(parsedAmount)) {
				this.amount = numeral(parsedAmount).format('0.00');
			}
		}
		catch (err) {
			console.error('Error encountered in querystring params.');
		}
	}

	search() {
		this.validationErrors = [];
		this.isSubmitting = true;
		let validator = new CustomerLookupValidator(this.i18n);
		if (validator.hasErrors(this.model, this.customerAccountNumberComponent, this.globalState.business.portalSettings)) {
			this.validationErrors = validator.errors;
			this.isSubmitting = false;
		} else {
			this.payrazrService.lookupCustomerByFilters(
				this.model.accountReferenceId,
				this.model.registrationId,
				this.model.registrationId2,
				this.model.registrationId3,
				this.model.zipCode,
				this.model.bucket ? this.model.bucket.bucketKey : null
			)
				.then(response => {
					this.isSubmitting = false;
					let result = response.entity;

					if (result == null) {
						if (response.message === 'customerAccountNotEligibleForPayments') {
							if (!this.globalState.business.portalSettings.csPhone) {
								this.errorMessage = this.i18n.t('customerAccountNotEligibleForPayments', { defaultValue: 'This account is not eligible for online payments.' });
							}
							else {
								this.errorMessage = this.i18n.t('customerAccountNotEligibleForPaymentsWithPhoneNumber', { defaultValue: `This account is not eligible for online payments, please contact us at ${this.globalState.business.portalSettings.csPhone}.`, phoneNumber: this.globalState.business.portalSettings.csPhone });
							}
						} else if (!this.globalState.business.portalSettings.csPhone) {
							this.errorMessage = this.i18n.t('customerAccountNotFoundError', { defaultValue: 'Account cannot be located. Please contact customer service.' });
						}
						else {
							this.errorMessage = this.i18n.t('customerAccountNotFoundErrorWithPhoneNumber', { defaultValue: `Account cannot be located. Please contact customer service at ${this.globalState.business.portalSettings.csPhone}`, phoneNumber: this.globalState.business.portalSettings.csPhone });
						}

						this.customer = null;
						this.hasLocatedAccount = false;

						return;
					}

					this.errorMessage = '';
					this.customer = new Customer(this.globalState.business, result);
					this.model.zipCode = this.model.zipCode ? this.model.zipCode : this.customer.primaryAddress.zip;
					this.customer.setZipCode(this.model.zipCode);
					this.customer.paymentMethods = null;
					this.account = this.customer.accounts.find(item => item.displayName.toUpperCase() === this.model.accountReferenceId.toUpperCase());
					if (!this.account) { this.account = this.customer.accounts[0]; }

					if (this.globalState.business.portalSettings.displayMinimumPaymentAmountOnPortal && this.account.minPayment && this.account.minPayment > 0) {
						this.minimumPaymentAmountMesssage = this.i18n.t('minimumPaymentOfXDueOnAccount', {
							defaultValue: `A minimum payment of ${FormattingHelper.formatCurrency(this.account.minPayment)} is due on this account.`,
							paymentAmount: FormattingHelper.formatCurrency(this.account.minPayment)
						});
					}

					// if we use RegistrationId, we cannot locate account according to it.
					// RegistrationId is for customer not for customer account
					this.amount = this.account.balance;
					this.hasLocatedAccount = true;
					let portfolioName = this.account.portfolioName;
					let portfolio = this.globalState.business.fetchPortfolioSettings(portfolioName);
					if (portfolio && portfolio.hasSettings) {
						this.globalState.business.applyPortfolioSettingsToPortal(this.account.portfolioName, true);
						this.applyPortfolioSettingsToPage();
						this.applyMerchantSettingsToPage(this.account.portfolioName);
					} else {
						this.customer = null;
						this.hasLocatedAccount = false;
						if (!this.globalState.business.portalSettings.csPhone) {
							this.errorMessage = this.i18n.t('portalConfigurationErrorContactCustomerService', 'Portal Configuration Error: The portfolio for this account has not been setup. Please contact customer service.');
						}
						else {
							this.errorMessage = this.i18n.t('portalConfigurationErrorContactCustomerServiceWithNumber', 'Portal Configuration Error: The portfolio for this account has not been setup. Please contact customer service at') + ' ' + this.globalState.business.portalSettings.csPhone + '.';
						}
					}
					this.paymentItemTableAccounts.push(this.account.customerAccountKey);
				})
				.catch(response => {
					this.isSubmitting = false;
					if (response.status === 404) {
						this.errorMessage = this.i18n.t('yourAccountNoLongerActive', 'Your account is no longer active. If you feel you have received this message in error, please contact customer service.');
					} else {
						this.customer = null;
						this.hasLocatedAccount = false;
						let baseMessage = this.i18n.t('unableToRetrieveAccountInformation', 'We are unable to retrieve your account information, please try again shortly.');
						if (!this.globalState.business.portalSettings.csPhone) {
							this.errorMessage = baseMessage;
						}
						else {
							this.errorMessage = baseMessage + ' ' + this.i18n.t('ifIssuePersistsPleaseContact', 'If the issue persists please contact us at') + ' ' + this.globalState.business.portalSettings.csPhone + '.';
						}
					}
				});
		}
	}

	applyMerchantSettingsToPage(portfolioName: string) {
		// the merchant settings come from the portfolio settings in this case, hence passing in portfolio name
		let portfolio = this.globalState.business.fetchPortfolioSettings(portfolioName);
		if (this.showSelectMerchant) {
			this.merchantKey = this.selectedMerchant?.merchantKey ?? 0;
			this.merchantConsumerPortalFeeSettings.feesEnabled = portfolio.merchantSettings.feeSettings.serviceFeeEnabled;
		}
		else if (portfolio && portfolio.hasSettings && portfolio.merchantSettings && portfolio.merchantSettings.feeSettings) {
			this.merchantKey = portfolio.merchantSettings.merchantKey;
			this.merchantConsumerPortalFeeSettings.feesEnabled = portfolio.merchantSettings.feeSettings.serviceFeeEnabled;
		} else {
			// theoretically shouldn't get here, but show an alert just in case
			alert('Could not retrieve merchant settings.');
		}
	}

	applyUnvalidatedMultiMerchantPortfolio(portfolioName: string) {
		let portfolio = this.globalState.business.fetchPortfolioSettings(portfolioName);
		this.showSelectMerchant = !this.requireAccountLookup && this.globalState.features.consumerPortalMultiZidEzPay && portfolio && portfolio.hasSettings && portfolio.portfolioName === '___ezpay' && !!portfolio.ezPayMerchants;
		if (this.showSelectMerchant) {
			this.merchantList = [...portfolio.ezPayMerchants];
			this.selectedMerchant = null;
			this.merchantKey = 0;
		}
	}

	applyPortfolioSettingsToPage() {
		this.minFuture = 0;
		let portalSettings = this.globalState.business.portalSettings;

		// this code is impacted by function "setMaxFuturePaymentDays" in portal.js model
		// this value could be the max of either the merchant or portfolio or ezpay depending on validation on/off
		if (portalSettings.paymentTypes && portalSettings.paymentTypes.maxFutureDays) {
			this.maxFuture = portalSettings.paymentTypes.maxFutureDays;
		}
		else { this.maxFuture = 1; }

		this.allowFuturePayment = false;
		this.allowPayToday = false;

		if (portalSettings.ezpay.paymentTypes && portalSettings.ezpay.accountNumberHandling !== 'lookup') {
			this.allowFuturePayment = portalSettings.ezpay.paymentTypes.allowFuture;
			this.allowPayToday = portalSettings.ezpay.paymentTypes.allowSingle;
		} else {
			if (portalSettings.paymentTypes) {
				this.allowFuturePayment = portalSettings.paymentTypes.allowFuture;
				this.allowPayToday = portalSettings.paymentTypes.allowSingle;
			}
		}

		if (this.allowPayToday) {
			this.minFuture = 0;
			this.model.paymentDate = moment.tz(this.globalState.business.businessTimezone).format('MM/DD/YYYY');
			if (!this.allowFuturePayment) {
				this.maxFuture = 0;
			}
		}
		else {
			this.minFuture = 1;
			this.model.paymentDate = moment(this.model.paymentDate, 'MM/DD/YYYY').add(1, 'day').format('MM/DD/YYYY');
		}

		this.title = this.allowFuturePayment ? 'makeAPayment' : 'makeAPaymentToday';
	}

	mfaClear(event: any) {
		this.pageState = this.pageStates.confirmation;
		this.verificationCode = event.detail.verificationCode;
		if (event.detail.mfaType === MfaTwoFactorMethod.SMS) {
			this.mfaEmail = null;
			this.mfaPhoneNumber = event.detail.mfaValue;
		} else {
			this.mfaPhoneNumber = null;
			this.mfaEmail = event.detail.mfaValue;
		}
	}

	showConfirmation(event) {
		// payment form errors
		this.validationErrors = event.detail.errors;

		// if no internal payment form errors, validate other parts of the payment form. Currently the payment form returns a list of errors OR payment info.
		// Now that payment info is needed for external validation, it would be ideal if it were refactored to return both errors AND payment info.
		if (event.detail.errors.length === 0) {
			this.validatePaymentDate(event.detail.date);
		}

		// page errors
		this.validatePaymentAmount();

		if (this.askForAccountNumber) {
			this.validateAccountNumber();
		}

		if (this.validationErrors.length > 0) {
			this.utility.scrollToTop();
			return;
		}
		else {
			let enteredPaymentDate = moment(event.detail.date, 'MM/DD/YYYY').format('MM/DD/YYYY');
			let today = moment.tz(this.globalState.business.businessTimezone).format('MM/DD/YYYY');
			this.isTodayPayment = (enteredPaymentDate === today);

			// trim cardholder name
			event.detail.name = event.detail.name.trim();

			// Need to rebuild the anonymous customer now that they've had time to enter the acct. number.
			if (this.askForAccountNumber && !this.requireAccountLookup) {
				let customer = Customer.anonymous(
					this.globalState.business,
					this.model.accountReferenceId,
					this.globalState.business.portalSettings.systemId || null,
					null,
					this.model.bucket ? this.model.bucket.bucketKey : null
				);
				this.account = customer.accounts[0];
			}

			this.movingToConfirmationPage = true;
			this.account.merchantZid = this.globalState.business.getMerchantZidAssociatedToPortfolioByPortfolioName(this.account.portfolioName);
			this.account.bucketKey = this.model.bucket ? this.model.bucket.bucketKey : null;
			this.paymentInformation = event.detail;
			this.amount = this.paymentInformation.amount;
			this.cardNumber = this.paymentInformation.card ? this.paymentInformation.card.cardNumber : null;

			this.getConfirmationTemplateData();

			// digital wallet fee calculation happens after instrument is selected
			if (this.isDigitalWalletPayment) {
				if (this.isApplePayPayment) {
					this.setApplePaySettingsFields();
				}
				this.movingToConfirmationPage = false;
				this.pageState = this.pageStates.confirmation;
			}
			else {
				this.payrazrService.calculateFee(event.detail.card ? true : false, this.account.portfolioName, event.detail.zipCode, event.detail.amount, this.cardNumber, null, this.account.customerAccountKey ? [this.account.customerAccountKey] : null, PaymentPlanType.NotSet , this.merchantKey)
					.then(result => {
						this.paymentInformation.fee = result.entity.fee;
						this.movingToConfirmationPage = false;

						if (this.isMfaEnabled && this.isCardPayment) {
							this.pageState = this.pageStates.mfa;
						} else {
							this.pageState = this.pageStates.confirmation;
						}
					})
					.catch(error => {
						this.movingToConfirmationPage = false;
						alert(this.i18n.t('unableToCommunicateWithServer', 'Unable to communicate with the server. Please try again.'));
					});
			}
		}
	}

	getConfirmationTemplateData() {
		const customObject: any = {};
		customObject.date = moment(this.paymentInformation.date).format('M/D/YYYY');
		customObject.amount = numeral(this.paymentInformation.amount).format('($0,0.00)');
		customObject.customerAccountNumber = this.account.referenceId || this.account.displayName;
		customObject.accountNumber = this.account.referenceId || this.account.displayName; // backward compatibility
		customObject.customerAccountName = this.account.name;
		customObject.accountName = this.account.displayName; // backward compatibility
		customObject.name = this.paymentInformation.name;
		customObject.address1 = this.paymentInformation.addressLine1;
		customObject.phone = this.phoneFormat.apply(this.paymentInformation.billingPhone); // todo: is this used?
		customObject.email = this.paymentInformation.billingEmail; // todo: is this used?
		customObject.zip = this.paymentInformation.zipCode;
		customObject.merchantZid = this.account.merchantZid;
		customObject.customerAccountLocationReferenceId = this.model.bucket ? this.model.bucket.referenceId : null;
		customObject.customerAccountLocationName = this.model.bucket ? this.model.bucket.displayName : null;
		customObject.billingPhone = this.phoneFormat.apply(this.paymentInformation.billingPhone);
		customObject.billingEmail = this.paymentInformation.billingEmail;

		if (this.isDigitalWalletPayment) {
			customObject.total = numeral(this.amount).format('($0,0.00)');
			customObject.description = this.paymentInformation.digitalWalletName;
			customObject.digitalWalletName = this.paymentInformation.digitalWalletName;
			customObject.totalLabel = this.merchantConsumerPortalFeeSettings.feesEnabled ? this.i18n.t('subTotal', 'Subtotal') + '*' : this.i18n.t('total', 'Total'),
				customObject.showDigitalWalletFeeDisclosure = this.merchantConsumerPortalFeeSettings.feesEnabled;
		}
		else if (this.isCardPayment) {
			customObject.fee = numeral(this.calculatedFeeAmount).format('($0,0.00)');
			customObject.total = numeral(this.calculatedTotalAmount).format('($0,0.00)');
			customObject.description = this.paymentInformation.transactionDescription;
			customObject.expData = this.paymentInformation.card.expirationDate;
			customObject.cardNumber = typeof this.paymentInformation.card.cardNumber !== 'undefined' ? '***' + FormattingHelper.mask(this.paymentInformation.card.cardNumber) : '';
		}
		else if (this.isCheckPayment) {
			customObject.fee = numeral(this.calculatedFeeAmount).format('($0,0.00)');
			customObject.total = numeral(this.calculatedTotalAmount).format('($0,0.00)');
			customObject.description = this.paymentInformation.transactionDescription;
			customObject.bankAccount = typeof this.paymentInformation.check.accountNumber !== 'undefined' ? '***' + FormattingHelper.mask(this.paymentInformation.check.accountNumber) : '';
			customObject.transitNumber = this.paymentInformation.check.transitNumber;
			customObject.checkNumber = this.paymentInformation.check.checkNumber;
		}

		this.accountPayments = this.getAccountsToPayForSubmission();
		this.selectedCustomerAccountKeys = this.accountPayments.reduce((customerAccountKeys: number[], accountPayment: ICustomerAccountToPay) =>
		{
			if (accountPayment.customerAccountKey) {
				customerAccountKeys.push(accountPayment.customerAccountKey);
			}
			return customerAccountKeys;
		}, []);

		const merchantKey = this.globalState.business.getMerchantKeyAssociatedToPortfolioByPortfolioName(this.account.portfolioName);
		this.confirmationTemplateData = new TemplateData(customObject, merchantKey, this.accountPayments, null, this.isEzpay);
	}

	setApplePaySettingsFields(): void {
		if (!this.paymentInformation.digitalWalletSettings?.isApplePay()) {
			return;
		}

		const applePaySettings: ApplePaySettings = this.paymentInformation.digitalWalletSettings as ApplePaySettings;
		applePaySettings.totalAmount = this.amount;

		if (!this.isTodayPayment) {
			applePaySettings.totalType = 'pending';
			applePaySettings.paymentTiming = 'deferred';
			applePaySettings.deferredPaymentDate = this.paymentInformation.date;
		}

		this.paymentInformation.digitalWalletSettings = applePaySettings;
	}

	submit(event: CustomEvent) {
		let submission;

		if (this.isTodayPayment) {
			submission = this.submitTodayPayment(event);
		} else {
			submission = this.submitFuturePayment(event);
		}

		return submission;
	}

	get confirmationTitle() {
		let makePaymentText: string = this.i18n.t('makePayment', 'Make Payment');
		return (!this.isTodayPayment) ?
			this.i18n.t('reviewInfoPressSchedulePayment', 'Please review the following information and press the Schedule Payment button') :
			this.i18n.t('reviewInfoPressMakePayment', {
				defaultValue: 'Please review the following information and press the Make Payment button.',
				payment: makePaymentText
			});
	}

	get confirmationSubmitButtonText() {
		return (!this.isTodayPayment) ?
			this.i18n.t('schedulePayment', 'Schedule Payment') :
			this.i18n.t('makePayment', 'Make Payment');
	}

	validatePaymentAmount() {
		if (this.requireAccountLookup) {
			let accountComponentValidaton = this.paymentItemTableViewModel.validate();

			if (accountComponentValidaton.confirm && accountComponentValidaton.errorMessages) {
				let confirmErrorMessage = accountComponentValidaton
					.errorMessages.splice(
						accountComponentValidaton.confirmErrorMessageIndex, 1);

				if (!confirm(...confirmErrorMessage)) {
					accountComponentValidaton.errorMessages.push(
						this.i18n.t('overPaymentsValidationNotice','Account is being overpaid.'));
				}
			}
			this.validationErrors = [...this.validationErrors, ...accountComponentValidaton.errorMessages];
		}
	}

	validatePaymentDate(enteredPaymentDate: string) {
		let paymentDate = moment(enteredPaymentDate, 'MM/DD/YYYY');
		let maxFuture = moment(moment.tz(this.globalState.business.businessTimezone).format('MM/DD/YYYY')).add(this.maxFuture, 'd').endOf('day');

		if (!paymentDate.isValid() || !paymentDate) {
			this.validationErrors.push(this.i18n.t('invalidPaymentDate', 'Invalid payment date'));
		}

		if (paymentDate < moment(moment.tz(this.globalState.business.businessTimezone).format('MM/DD/YYYY')).startOf('day')) {
			this.validationErrors.push(this.i18n.t('paymentDateCannotBeInPast', 'Payment date cannot be in the past'));
		}
		if (paymentDate > maxFuture) {
			this.validationErrors.push(`Payment date cannot be more than ${this.maxFuture} day${this.maxFuture > 1 ? 's' : ''} from now`);
		}
	}

	validateAccountNumber() {
		let validator = new NoLookupValidator();

		let accountReferenceId = this.model.accountReferenceId;

		accountReferenceId = (typeof (accountReferenceId) === 'undefined') ? '' : accountReferenceId;
		if (accountReferenceId.lastIndexOf('-') === accountReferenceId.length - 1) {
			accountReferenceId = accountReferenceId.substring(0, accountReferenceId.lastIndexOf('-'));
		}

		this.model.accountReferenceId = accountReferenceId;

		if (validator.hasErrors(this.model, this.customerAccountNumberComponent, this.globalState.business.portalSettings)) {
			this.validationErrors = this.validationErrors.concat(validator.errors);
			return;
		}
	}

	submitTodayPayment(event: CustomEvent): Promise<any> {
		let submission;

		let isEmailOptedIn: boolean | null;
		if (this.globalState.business.portalSettings.fields.billingEmail.visible) {
			isEmailOptedIn = this.paymentInformation.isEmailOptedIn;
			this.globalState.customer.email = this.paymentInformation.billingEmail; // Set email for receipt page
		}

		if (this.paymentInformation.card) {
			submission = this.payrazrService.submitCardPaymentV2(
				this.customer,
				this.account,
				this.paymentInformation.name,
				this.paymentInformation.addressLine1,
				this.paymentInformation.billingCity,
				this.paymentInformation.billingState,
				this.paymentInformation.zipCode,
				this.paymentInformation.billingPhone,
				this.paymentInformation.billingEmail,
				isEmailOptedIn,
				this.paymentInformation.transactionDescription,
				this.paymentInformation.isThirdPartyPayment,
				this.paymentInformation.amount,
				this.paymentInformation.fee,
				this.paymentInformation.card,
				null,
				false,
				0,
				this.account.bucketKey,
				this.merchantKey,
				this.recpatchaV2Token,
				!this.requireAccountLookup,
				this.verificationCode,
				this.mfaEmail,
				this.mfaPhoneNumber
			);
		} else if (this.paymentInformation.digitalWalletSettings) {
			let request = new SubmitDigitalWalletPaymentRequest();
			request.customerAccountId = this.account.id;
			request.portalId = this.globalState.business.portalId;
			request.bucketKey = this.account.bucketKey;
			request.merchantKey = this.merchantKey;
			request.digitalWalletPaymentDetails = this.getDigitalWalletPaymentDetails(event.detail);
			// submit digital wallet payment
			submission = this.payrazrService.submitCardDigitalWalletPayment(request);
		} else {
			submission = this.payrazrService.submitCheckPaymentV2(
				this.customer,
				this.account,
				this.paymentInformation.name,
				this.paymentInformation.addressLine1,
				this.paymentInformation.billingCity,
				this.paymentInformation.billingState,
				this.paymentInformation.zipCode,
				this.paymentInformation.billingPhone,
				this.paymentInformation.billingEmail,
				isEmailOptedIn,
				this.paymentInformation.transactionDescription,
				this.paymentInformation.isThirdPartyPayment,
				this.paymentInformation.amount,
				this.paymentInformation.fee,
				this.paymentInformation.check,
				null,
				false,
				0,
				this.account.bucketKey,
				this.merchantKey,
				this.recpatchaV2Token,
				!this.requireAccountLookup
			);
		}

		return submission
			.then(result => {
				if (result.response.isSuccessful) {
					this.pageState = this.pageStates.receipt;
					this.confirmationId = result.confirmationNumber;
					this.date = result.date;
					this.time = result.time;
					this.type = result.type;
					this.subtotal = result.subtotal;
					this.serviceFee = result.serviceFee;
					this.total = result.total;
					this.info = result.info;
					this.name = result.name;
					this.result = result.result;
					this.pnref = result.response.pnref;
					this.portalTemplateType = this.templateService.getPortalTemplateType(this.paymentInformation, false);
					this.savedPaymentMethodToWallet = result.response.savedPaymentMethodToWallet;
					this.enableEditTransaction = false;

					if (result.response.hasException) {
						this.customMessage = result.response.message;
					}
				}
				else {
					this.pageState = this.pageStates.receipt;
					this.portalTemplateType = PortalTemplateTypes.TransactionFailed;
					this.savedPaymentMethodToWallet = result.response.savedPaymentMethodToWallet;
					this.resultCode = result.response.resultCode;
					this.resultMessage = result.response.message;
					this.enableEditTransaction = this.globalState.business.portalSettings.businessSettings.enablePortalEditTransaction;
				}

				// complete digital wallet session
				if (this.isApplePayPayment) {
					const isSuccessful: boolean = result.response.isSuccessful && !result.response.hasException;
					ApplePayUtil.completeSession(event, isSuccessful);
				}

				this.isSubmitting = false;
			})
			.catch((error) => {
				this.isSubmitting = false;
				this.transactionError = error;

				if (this.isApplePayPayment) {
					const isSuccessful: boolean = false;
					ApplePayUtil.completeSession(event, isSuccessful);
				}
			});
	}

	getDigitalWalletPaymentDetails(digitalWalletEventData: any): DigitalWalletPaymentDetails {
		if (digitalWalletEventData === null) {
			return null;
		}

		let digitalWalletPaymentDetails: DigitalWalletPaymentDetails = new DigitalWalletPaymentDetails();

		// digital wallet specific
		if (digitalWalletEventData.digitalWalletType === DigitalWalletType.ApplePay) {
			digitalWalletPaymentDetails.calculatedServiceFee = digitalWalletEventData.calculatedServiceFee; // informational only

			const applePayPayment: ApplePayJS.ApplePayPayment = digitalWalletEventData.payment;
			digitalWalletPaymentDetails.digitalWalletType = DigitalWalletType.ApplePay;

			const applePayPaymentToken = JSON.stringify(applePayPayment.token);
			digitalWalletPaymentDetails.authenticationPaymentToken = btoa(applePayPaymentToken);

			digitalWalletPaymentDetails.accountName = applePayPayment.billingContact?.givenName + ' ' + applePayPayment.billingContact?.familyName;
			digitalWalletPaymentDetails.address = applePayPayment.billingContact?.addressLines ? applePayPayment.billingContact?.addressLines[0] : '';
			digitalWalletPaymentDetails.zipCode = applePayPayment.billingContact?.postalCode ?? '';
			digitalWalletPaymentDetails.isDebitCard = applePayPayment.token.paymentMethod.type === 'debit';
			digitalWalletPaymentDetails.isCreditCard = applePayPayment.token.paymentMethod.type === 'credit';

			console.log('EZPAY stringified token:', applePayPaymentToken);
			console.log('EZPAY dw payment method: ', digitalWalletPaymentDetails);
		}

		return digitalWalletPaymentDetails;
	}

	submitFuturePayment(submitEvent: CustomEvent): Promise<any> {
		let paymentDate = moment(this.paymentInformation.date);
		let submission;

		let isEmailOptedIn: boolean | null;
		if (this.globalState.business.portalSettings.fields.billingEmail.visible) {
			isEmailOptedIn = this.paymentInformation.isEmailOptedIn;
		}

		if (this.isDigitalWalletPayment) {
			let digitalWalletPaymentPlanDetails = this.getDigitalWalletPaymentPlanDetailsFromSubmitEvent(submitEvent);
			submission = this.payrazrService.submitDigitalWalletPaymentPlan(
				this.account,
				digitalWalletPaymentPlanDetails,
				this.merchantKey);
		} else if (this.isCardPayment) {
			submission = this.payrazrService.submitCardPaymentPlan(
				this.account,
				0,
				this.paymentInformation.amount,
				1,
				paymentDate,
				this.paymentInformation.name,
				this.paymentInformation.addressLine1,
				this.paymentInformation.billingCity,
				this.paymentInformation.billingState,
				this.paymentInformation.billingPhone,
				this.paymentInformation.billingEmail,
				isEmailOptedIn,
				this.paymentInformation.zipCode,
				this.paymentInformation.fee,
				this.paymentInformation.transactionDescription,
				this.paymentInformation.isThirdPartyPayment,
				this.paymentInformation.card,
				0,
				false,
				false,
				0,
				null,
				this.merchantKey
			);
		} else if (this.paymentInformation.check) {
			submission = this.payrazrService.submitCheckPaymentPlan(
				this.account,
				0,
				this.paymentInformation.amount,
				1,
				paymentDate,
				this.paymentInformation.name,
				this.paymentInformation.addressLine1,
				this.paymentInformation.billingCity,
				this.paymentInformation.billingState,
				this.paymentInformation.billingPhone,
				this.paymentInformation.billingEmail,
				isEmailOptedIn,
				this.paymentInformation.zipCode,
				this.paymentInformation.fee,
				this.paymentInformation.transactionDescription,
				this.paymentInformation.isThirdPartyPayment,
				this.paymentInformation.check,
				0,
				false,
				false,
				0,
				null,
				this.merchantKey
			);
		}

		return submission
			.then(result => {
				if (result.response.isSuccessful) {
					this.pageState = this.pageStates.receipt;
					this.confirmationId = result.confirmationNumber;
					this.date = result.date;
					this.time = result.time;
					this.type = result.type;
					this.subtotal = result.subtotal;
					this.serviceFee = result.serviceFee;
					this.total = result.total;
					this.info = result.info;
					this.name = result.name;
					this.result = result.result;
					this.planId = result.response.planId;
					this.portalTemplateType = this.isCardPayment
						? PortalTemplateTypes.CreditCardInstallmentPlanReceipt
						: PortalTemplateTypes.CheckInstallmentPlanReceipt;
					this.savedPaymentMethodToWallet = result.response.savedPaymentMethodToWallet;
					this.enableEditTransaction = false;
				}
				else {
					this.pageState = this.pageStates.receipt;
					this.portalTemplateType = PortalTemplateTypes.TransactionFailed;
					this.savedPaymentMethodToWallet = result.response.savedPaymentMethodToWallet;
					this.resultCode = result.response.resultCode;
					this.resultMessage = result.response.message;
					this.enableEditTransaction = this.globalState.business.portalSettings.businessSettings.enablePortalEditTransaction;
				}

				// complete digital wallet session
				if (this.isApplePayPayment) {
					const isSuccessful: boolean = result.response.isSuccessful;
					ApplePayUtil.completeSession(submitEvent, isSuccessful);
				}

				this.isSubmitting = false;
			})
			.catch((error) => {
				// complete digital wallet session
				if (this.isApplePayPayment) {
					const isSuccessful: boolean = false;
					ApplePayUtil.completeSession(submitEvent, isSuccessful);
				}

				this.isSubmitting = false;
				this.transactionError = error;
			});
	}

	verifyCaptcha(verifyCaptchaEvent: CustomEvent) {
		this.recpatchaV2Token = verifyCaptchaEvent.detail;
	}

	captchaExpired() {
		this.recpatchaV2Token = '';
	}

	getDigitalWalletPaymentPlanDetailsFromSubmitEvent(submitEvent: CustomEvent): DigitalWalletPaymentPlanDetails {
		if (submitEvent === null) {
			return null;
		}

		let digitalWalletPaymentPlanDetails: DigitalWalletPaymentPlanDetails = new DigitalWalletPaymentPlanDetails();

		// digital wallet specific
		if (submitEvent.detail.digitalWalletType === DigitalWalletType.ApplePay) {
			const applePayPayment: ApplePayJS.ApplePayPayment = submitEvent.detail.payment;
			const applePayPaymentToken = JSON.stringify(applePayPayment.token);

			digitalWalletPaymentPlanDetails.authenticationPaymentToken = btoa(applePayPaymentToken);
			digitalWalletPaymentPlanDetails.digitalWalletType = DigitalWalletType.ApplePay;
			digitalWalletPaymentPlanDetails.isDebitCard = applePayPayment.token.paymentMethod.type === 'debit';
			digitalWalletPaymentPlanDetails.isCreditCard = applePayPayment.token.paymentMethod.type === 'credit';
			digitalWalletPaymentPlanDetails.accountName = applePayPayment.billingContact?.givenName + ' ' + applePayPayment.billingContact?.familyName;
			digitalWalletPaymentPlanDetails.calculatedServiceFee = submitEvent.detail.calculatedServiceFee; // informational only
			digitalWalletPaymentPlanDetails.addressLine1 = applePayPayment.billingContact?.addressLines ? applePayPayment.billingContact?.addressLines[0] : '';
			digitalWalletPaymentPlanDetails.zipCode = applePayPayment.billingContact?.postalCode ?? '';
			digitalWalletPaymentPlanDetails.saveToWallet = false;
			digitalWalletPaymentPlanDetails.numberOfPayments = 1;
			digitalWalletPaymentPlanDetails.firstPaymentDate = moment(this.paymentInformation.date);
			digitalWalletPaymentPlanDetails.paymentAmount = Number(this.amount);
			digitalWalletPaymentPlanDetails.maxRetries = 0;
			digitalWalletPaymentPlanDetails.isRehab = false;
			digitalWalletPaymentPlanDetails.description = DigitalWalletType.ApplePay.toString();
			digitalWalletPaymentPlanDetails.isThirdParty = false;
			digitalWalletPaymentPlanDetails.discountAmount = 0;
		}

		return digitalWalletPaymentPlanDetails;
	}

	private getAccountsToPayForSubmission(): ICustomerAccountToPay[] {
		let accountsToPay: ICustomerAccountToPay[] = [];

		if (!this.requireAccountLookup) {
			// assemble info for unvalidated ezpay
			accountsToPay.push({
				referenceId: this.model.accountReferenceId,
				paymentAmount: this.amount,
				merchantKey: this.merchantKey
			} as ICustomerAccountToPay);
		} else {
			// assemble info for validated ezpay
			let selectedPaymentItems: AccountPaymentItem[] = this.paymentItemTableViewModel.getSelectedItems();
			selectedPaymentItems.forEach((i: AccountPaymentItem) => {
				accountsToPay.push({
					customerAccountKey: i.itemKey,
					paymentAmount: NumberHelper.parseCurrency(i.enteredAmount),
					merchantKey: i.merchantKey,
					paymentBalanceType: i.paymentBalanceType,
					paymentLimitSettings: i.paymentLimitSettings,
					minPaymentDue: i.minPaymentDue
				} as ICustomerAccountToPay);
			});
		}

		return accountsToPay;
	}

	updateAccountTableSubtotal(): void {
		this.amount = this.paymentItemTableViewModel.getTotalEnteredAmountForSelectedItems();
	}

	paymentAmountChanged() {
		this.amount = numeral(this.amount).format('0.00');
	}

	showLegalModal(content:string) {
		if (content === 'terms') {
			this.dialogService.open({ viewModel: LegalTermsDialog, lock: false });
		}
	}

	handleSelectMerchantChanged(event, merchant: Merchant) {
		this.hasLocatedAccount = this.selectedMerchant?.merchantKey > 0;
		this.validationErrors = [];
		this.globalState.business.applyPortfolioSettingsToPortal(this.account.portfolioName, true, this.selectedMerchant.merchantKey);
		this.applyPortfolioSettingsToPage();
		this.applyMerchantSettingsToPage(this.account.portfolioName);
		this.publishEventsAfterMerchantSelected();
	}

	publishEventsAfterMerchantSelected() {
		this.eventAggregator.publish('portalSettingsCardsAcceptedChanged', this.globalState.business.portalSettings.cardsAccepted);
		this.eventAggregator.publish('ezPayMerchantSelectedChangedEvent', this.selectedMerchant?.merchantKey ?? 0);
	}

	@computedFrom('pageState')
	get showStartButton() {
		return this.pageState === this.pageStates.start;
	}
	@computedFrom('pageState')
	get showTerms() {
		return this.pageState === this.pageStates.terms;
	}
	@computedFrom('pageState')
	get showDisclosures() {
		return this.pageState === this.pageStates.disclosures;
	}
	@computedFrom('pageState')
	get showPaymentForm() {
		return this.pageState === this.pageStates.payment;
	}
	@computedFrom('pageState')
	get showConfirmationPage() {
		return this.pageState === this.pageStates.confirmation;
	}
	@computedFrom('pageState')
	get showReceiptPage() {
		return this.pageState === this.pageStates.receipt;
	}
	@computedFrom('pageState')
	get showMfaPage() {
		return this.pageState === this.pageStates.mfa
			&& (this.globalState.business?.portalSettings?.businessSettings?.useMFAForUnvalidatedEzPay ?? false)
			// and is unvalidated
			&& !this.requireAccountLookup
			&& this.globalState.features.unvalidatedEzPayMFA;
	}
	@computedFrom('pageState')
	get isMfaEnabled() {
		return !this.requireAccountLookup
			&& (this.globalState.business?.portalSettings?.businessSettings?.useMFAForUnvalidatedEzPay ?? false)
			&& this.globalState.features.unvalidatedEzPayMFA;
	}

	get requireCaptchaV2() {
		return this.globalState.business?.portalSettings?.businessSettings?.useRecaptchaV2 ?? false;
	}
}

export class Model {
	accountReferenceId: any;
	paymentDate: any;
	registrationId: any;
	registrationId2: any;
	registrationId3: any;
	zipCode: any;
	bucketKey: number | null;

	constructor() {
		this.accountReferenceId = ''; // "C12345";
		this.paymentDate = moment().format('MM/DD/YYYY');

		this.registrationId = '';
		this.registrationId2 = '';
		this.registrationId3 = '';
		this.zipCode = '';
		this.bucketKey = null;
	}
}

export class NoLookupValidator {
	errors: any;

	constructor() {
		this.errors = [];
	}

	hasErrors(model, customerAccountNumberComponent, portalSettings) {

		customerAccountNumberComponent.validate(this.errors);

		return this.errors.length > 0;
	}
}
export class CustomerLookupValidator {
	errors: any;
	i18n: any;
	constructor(i18next: any) {
		this.errors = [];
		this.i18n = i18next;
	}

	hasErrors(model, customerAccountNumberComponent, portalSettings) {
		if (portalSettings.ezpay.accountNumberSettings[0].required) {
			customerAccountNumberComponent.validate(this.errors);
		}

		if (portalSettings.ezpay.registrationIdSettings.required) {
			if (model.registrationId.length === 0) {
				let label = '';
				if (portalSettings.ezpay.registrationIdSettings.label) { label = portalSettings.ezpay.registrationIdSettings.label; }
				else { label = this.i18n.t('registrationId', 'Registration Id'); }
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label }));
			}
		}

		if (portalSettings.ezpay.registrationId2Settings.required) {
			if (model.registrationId2.length === 0) {
				let label = '';
				if (portalSettings.ezpay.registrationId2Settings.label) { label = portalSettings.ezpay.registrationId2Settings.label; }
				else { label = this.i18n.t('registrationIdTwo', 'Registration Id 2'); }
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label }));
			}
		}

		if (portalSettings.ezpay.registrationId3Settings.required) {
			if (model.registrationId3.length === 0) {
				let label = '';
				if (portalSettings.ezpay.registrationId3Settings.label) { label = portalSettings.ezpay.registrationId3Settings.label; }
				else { label = this.i18n.t('registrationIdThree', 'Registration Id 3'); }
				this.errors.push(this.i18n.t('pleaseEnterYour', { defaultValue: 'Please enter your ' + label, label }));
			}
		}

		if (portalSettings.ezpay.zipcodeSettings.required) {
			if (model.zipCode.length === 0) {
				this.errors.push(this.i18n.t('enterZipBeforeContinuing', 'Please enter your zip code before continuing'));
			} else if (!ValidationHelpers.isZipCode(model.zipCode)) {
				this.errors.push(this.i18n.t('enterValidFiveOrNineDigitZipCode', 'Please enter a valid 5 or 9 digit zip code'));
			}
		}

		return this.errors.length > 0;
	}
}
